/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_No_Event_Aria_LabelInputs */

const en_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event selected`)
};

const fr_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement selectionne`)
};

const de_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Veranstaltung ausgewählt`)
};

const it_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento selezionato`)
};

const ru_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие не выбрано`)
};

const es_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún evento seleccionado`)
};

const zh_cn2_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何事件`)
};

const ja_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントが選択されていません`)
};

const hi_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई इवेंट चयनित नहीं है`)
};

const pt_pt2_notes_no_event_aria_label = /** @type {(inputs: Notes_No_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento selecionado`)
};

/**
* | output |
* | --- |
* | "No event selected" |
*
* @param {Notes_No_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_no_event_aria_label = /** @type {((inputs?: Notes_No_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_No_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_no_event_aria_label(inputs)
	if (locale === "de") return de_notes_no_event_aria_label(inputs)
	if (locale === "it") return it_notes_no_event_aria_label(inputs)
	if (locale === "ru") return ru_notes_no_event_aria_label(inputs)
	if (locale === "es") return es_notes_no_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_no_event_aria_label(inputs)
	if (locale === "ja") return ja_notes_no_event_aria_label(inputs)
	if (locale === "hi") return hi_notes_no_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_no_event_aria_label(inputs)
	return en_notes_no_event_aria_label(inputs)
});